import DsButton from './Button'

/**
 * One way to save, in every section that can be edited.
 *
 * Each form used to end in a Save button of its own, which meant the control
 * sat wherever that form happened to stop — sometimes below the fold, always in
 * a different place per tab. The bar rides the bottom of the scroller instead,
 * appears only once something has actually changed, and says how much.
 *
 * `-mx` cancels `main`'s padding exactly, so the bar bleeds to the edges of the
 * page while its contents stay on the same grid as everything above.
 */
const SettingsSaveBar = ({
  dirtyCount,
  isSubmitting = false,
  canSave = true,
  onSave,
  onDiscard,
}: {
  /** Nothing is drawn at zero: a bar that is always there is furniture. */
  dirtyCount: number,
  isSubmitting?: boolean,
  /** False while the form holds a value the API would reject. */
  canSave?: boolean,
  onSave: () => void,
  onDiscard: () => void,
}) => {
  if (dirtyCount <= 0) {
    return null;
  }

  return (
    <div className="sticky bottom-0 z-30 -mx-4 lg:-mx-8 mt-6 px-4 lg:px-8 py-3 bg-navy-800/95 backdrop-blur-sm border-t border-navy-500 flex items-center justify-between gap-3">
      <span className="text-ds-135 text-navy-200">
        {dirtyCount} unsaved change{dirtyCount === 1 ? '' : 's'} in this section
      </span>
      <div className="flex items-center gap-2 flex-none">
        <DsButton variant="outline" onClick={onDiscard} isDisabled={isSubmitting}>
          Discard
        </DsButton>
        <DsButton variant="primary" onClick={onSave} isDisabled={isSubmitting || !canSave}>
          {isSubmitting ? 'Saving…' : 'Save changes'}
        </DsButton>
      </div>
    </div>
  );
}

export default SettingsSaveBar
